import { StaysViewContainer } from 'Views/account/stays/StaysView.container';
export default StaysViewContainer;
